import clsx from 'clsx'
import { type ReactElement, useMemo } from 'react'
import { useWatch } from 'react-hook-form'
import { formatAmount } from '~/common/utils'
import type { InputInFormProps } from '~/components/Form/Input/input'
import { useTaxonomy } from '~/domains/taxonomies/queries/useTaxonomy'
import { computeInvoiceTotals } from '../utils/invoiceTotals'
import {
  totalLineFinal,
  totalLineFirst,
  totalLinePayment,
  totalsSection,
  totalValue,
  totalValueFinal
} from './InvoiceModal.css'

type InvoiceTotalsProps = InputInFormProps & {
  name?: string
  isEditMode: boolean
  invoice?: any
}

export const InvoiceTotals = ({
  control,
  isEditMode,
  invoice
}: InvoiceTotalsProps): ReactElement => {
  const { data: vatRates = [] } = useTaxonomy('vat_rates')
  const lines = useWatch({ control, name: 'lines' }) || []
  const watchedPaidAmount = useWatch({ control, name: 'paidAmount' })

  const { totalHT, totalTTC } = useMemo(
    () =>
      computeInvoiceTotals(
        (Array.isArray(lines) ? lines : []).map((line: any) => {
          const vatRateRaw = line?.vatRateId
          const vatRateId =
            typeof vatRateRaw === 'string'
              ? vatRateRaw.includes('/')
                ? vatRateRaw.split('/').pop() || ''
                : vatRateRaw
              : ''
          const vatRateObj = vatRates.find(
            (vr) => String(vr.id) === String(vatRateId)
          )

          return {
            quantity: Number(line?.quantity) || 0,
            unitPriceHT: Number(line?.unitPriceHT) || 0,
            rate: Number((vatRateObj as any)?.rate ?? 0)
          }
        })
      ),
    [lines, vatRates]
  )

  return (
    <div className={totalsSection}>
      <div className={clsx(totalLinePayment, totalLineFirst)}>
        <span>Total HT :</span>
        <span className={totalValue}>{formatAmount(totalHT)} €</span>
      </div>
      <div className={totalLineFinal}>
        <span>Total TTC :</span>
        <span className={totalValueFinal}>{formatAmount(totalTTC)} €</span>
      </div>

      {isEditMode && (
        <div className={totalLinePayment}>
          <span>Montant réglé :</span>
          <span className={totalValue}>
            {formatAmount(
              Number(watchedPaidAmount ?? invoice?.paidAmount ?? 0) || 0
            )}{' '}
            €
          </span>
        </div>
      )}
    </div>
  )
}
